import 'reflect-metadata';
import Vue from 'vue';
import { mixins, createDecorator } from 'vue-class-component';
import { mapState, mapMutations, mapActions } from 'vuex';
import { VuexModule, Mutation, Module, Action } from 'vuex-module-decorators';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var API_OPTIONS_METADATA_KEY = 'Api:option';
var API_TYPE_METADATA_KEY = 'Api:type';
var SPECTRA_APIS_METADATA_KEY = 'Spectra:apis';
var WEAVER_MODULES_METADATA_KEY = 'Weaver:apis';
var PRISM_ORDER_METADATA_KEY = 'Prism:order';
var PRISM_EXCLUDE_METADATA_KEY = 'Prism:exclude';
var PRISM_INCLUDE_METADATA_KEY = 'Prism:include';

var SpectraPrism = /** @class */ (function () {
    function SpectraPrism() {
    }
    return SpectraPrism;
}());
function Order(order) {
    return function (target) {
        Reflect.defineMetadata(PRISM_ORDER_METADATA_KEY, order, target);
        return target;
    };
}
function Exclude() {
    var name = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        name[_i] = arguments[_i];
    }
    return function (target) {
        Reflect.defineMetadata(PRISM_EXCLUDE_METADATA_KEY, name, target);
        return target;
    };
}
function Include() {
    var name = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        name[_i] = arguments[_i];
    }
    return function (target) {
        Reflect.defineMetadata(PRISM_INCLUDE_METADATA_KEY, name, target);
        return target;
    };
}

var SpectraModule = /** @class */ (function () {
    function SpectraModule() {
    }
    return SpectraModule;
}());

var prefixName = function (name, prefix) { return "".concat(prefix, "$").concat(name); };
var getAopMethods = function (methods) {
    var globalMethods = methods.globalMethods, moduleMethods = methods.moduleMethods, name = methods.name;
    if (methods.length === globalMethods.length + moduleMethods.length) {
        return methods;
    }
    methods.length = 0;
    methods.push.apply(methods, __spreadArray(__spreadArray([], moduleMethods, true), globalMethods, true).filter(function (item) {
        if (item.exclude) {
            return !item.exclude.includes(name);
        }
        if (item.include) {
            return item.include.includes(name);
        }
        return true;
    }));
    methods.sort(function (a, b) { return a.order - b.order; });
    return methods;
};
var SpectraCreator = /** @class */ (function () {
    function SpectraCreator(options) {
        Object.defineProperty(this, "spectraModuleMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "globalPrismMap", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // private spectraWeavers: SpectraComponentClass<any>[];
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "extractDataKey", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.options = options;
        this.extractDataKey = options.extractDataKey;
        this.spectraModuleMap = {};
        this.globalPrismMap = {
            beforeActions: [],
            afterActions: [],
            pendingActions: [],
        };
        // this.spectraWeavers = [];
        this.Spectra = this.Spectra.bind(this);
        this.Weaver = this.Weaver.bind(this);
        this.spectraWeaverFactory = this.spectraWeaverFactory.bind(this);
        this.spectraModuleFactory = this.spectraModuleFactory.bind(this);
    }
    Object.defineProperty(SpectraCreator.prototype, "Weaver", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var modules = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                modules[_i] = arguments[_i];
            }
            var vueModules = [];
            var spectraModules = [];
            modules.forEach(function (module) {
                if (module.prototype instanceof Vue || Object.getPrototypeOf(module.prototype) === Vue.prototype) {
                    vueModules.push(module);
                }
                else {
                    spectraModules.push(module);
                }
            });
            var WeaverComponent = /** @class */ (function (_super) {
                __extends(WeaverComponent, _super);
                function WeaverComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return WeaverComponent;
            }(mixins.apply(void 0, vueModules)));
            Reflect.defineMetadata(WEAVER_MODULES_METADATA_KEY, spectraModules.map(function (module) {
                var moduleName = module._vmdModuleName;
                var namespaced = module.namespaced;
                var _a = Reflect.getMetadata(SPECTRA_APIS_METADATA_KEY, module) || {}, _b = _a.apiKeys, apiKeys = _b === void 0 ? [] : _b, _c = _a.pureApiKeys, pureApiKeys = _c === void 0 ? [] : _c;
                return { moduleName: moduleName, namespaced: namespaced, apiKeys: apiKeys, pureApiKeys: pureApiKeys };
            }), WeaverComponent);
            return WeaverComponent;
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "Spectra", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (options) {
            var _this = this;
            var prismOptions = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                prismOptions[_i - 1] = arguments[_i];
            }
            if (typeof options === 'function') {
                var originalPrototype = options.prototype;
                if (originalPrototype instanceof SpectraPrism) {
                    return this.spectraPrismFactory(options);
                }
                if (originalPrototype instanceof Vue) {
                    return this.spectraWeaverFactory(options);
                }
                if (originalPrototype instanceof SpectraModule) {
                    return this.spectraModuleFactory(options);
                }
                if (originalPrototype instanceof VuexModule) {
                    return function (target) { return _this.spectraPrismFactory(target, __spreadArray([options], prismOptions, true)); };
                }
                return options;
            }
            return function (target) {
                var originalPrototype = target.prototype;
                if (originalPrototype instanceof SpectraPrism) {
                    return _this.spectraPrismFactory(target, __spreadArray([options], prismOptions, true));
                }
                if (originalPrototype instanceof Vue) {
                    return _this.spectraWeaverFactory(target);
                }
                if (originalPrototype instanceof SpectraModule) {
                    return _this.spectraModuleFactory(target, options);
                }
                return target;
            };
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "spectraPrismFactory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target, spectraModules) {
            var _this = this;
            var instance = new target.prototype.constructor();
            var proto = Object.getPrototypeOf(instance);
            var methods = Object.getOwnPropertyNames(proto).reduce(function (obj, key) {
                if (['beforeAction', 'pendingAction', 'afterAction'].includes(key) && typeof instance[key] === 'function') {
                    obj[key] = instance[key];
                }
                return obj;
            }, {});
            var order = Reflect.getMetadata(PRISM_ORDER_METADATA_KEY, target) || Number.MAX_SAFE_INTEGER;
            var include = Reflect.getMetadata(PRISM_INCLUDE_METADATA_KEY, target);
            var exclude = Reflect.getMetadata(PRISM_EXCLUDE_METADATA_KEY, target);
            var isGlobalPrism = !(spectraModules === null || spectraModules === void 0 ? void 0 : spectraModules.length);
            if (isGlobalPrism) {
                if (methods.beforeAction) {
                    methods.beforeAction.order = order;
                    methods.beforeAction.include = include;
                    methods.beforeAction.exclude = exclude;
                    this.globalPrismMap.beforeActions.push(methods.beforeAction);
                }
                if (methods.pendingAction) {
                    methods.pendingAction.order = order;
                    methods.pendingAction.include = include;
                    methods.pendingAction.exclude = exclude;
                    this.globalPrismMap.pendingActions.push(methods.pendingAction);
                }
                if (methods.afterAction) {
                    methods.afterAction.order = order;
                    methods.afterAction.include = include;
                    methods.afterAction.exclude = exclude;
                    this.globalPrismMap.afterActions.push(methods.afterAction);
                }
            }
            else {
                spectraModules.forEach(function (module) {
                    var _a, _b, _c;
                    var moduleName = module._vmdModuleName;
                    if (moduleName && _this.spectraModuleMap[moduleName]) {
                        if (methods.beforeAction) {
                            methods.beforeAction.order = order;
                            methods.beforeAction.include = include;
                            methods.beforeAction.exclude = exclude;
                            (_a = _this.spectraModuleMap[moduleName].beforeActions) === null || _a === void 0 ? void 0 : _a.push(methods.beforeAction);
                        }
                        if (methods.pendingAction) {
                            methods.pendingAction.order = order;
                            methods.pendingAction.include = include;
                            methods.pendingAction.exclude = exclude;
                            (_b = _this.spectraModuleMap[moduleName].pendingActions) === null || _b === void 0 ? void 0 : _b.push(methods.pendingAction);
                        }
                        if (methods.afterAction) {
                            methods.afterAction.order = order;
                            methods.afterAction.include = include;
                            methods.afterAction.exclude = exclude;
                            (_c = _this.spectraModuleMap[moduleName].afterActions) === null || _c === void 0 ? void 0 : _c.push(methods.afterAction);
                        }
                    }
                });
            }
            return target;
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "spectraModuleFactory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (target, options) {
            var _this = this;
            if (options === void 0) { options = {}; }
            var originalPrototype = target.prototype;
            var apiKeys = [];
            var pureApiKeys = [];
            var instance = new originalPrototype.constructor({});
            var extractDataKey = this.extractDataKey;
            var SpectraModule = /** @class */ (function (_super) {
                __extends(SpectraModule, _super);
                function SpectraModule() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    _super.apply(this, args) || this;
                    return instance;
                }
                return SpectraModule;
            }(VuexModule));
            var moduleName = options.name || target.name;
            if (moduleName) {
                if (!this.spectraModuleMap[moduleName]) {
                    this.spectraModuleMap[moduleName] = { module: SpectraModule, afterActions: [], beforeActions: [], pendingActions: [] };
                }
            }
            var spectraModule = moduleName ? this.spectraModuleMap[moduleName] : { module: SpectraModule };
            Object.keys(instance).forEach(function (name) {
                var api = instance[name];
                if (typeof api !== 'function')
                    return;
                var apiOptions = Reflect.getMetadata(API_OPTIONS_METADATA_KEY, originalPrototype, name);
                var apiType = Reflect.getMetadata(API_TYPE_METADATA_KEY, originalPrototype, name);
                if (!apiType)
                    return;
                var isPureApi = apiType === 'pure';
                var actionName = prefixName(name, 'action');
                var mutationName = prefixName(name, 'mutation');
                var moduleApiContext = __assign(__assign(__assign({ name: name, moduleName: moduleName }, (extractDataKey && { extractDataKey: extractDataKey })), (!isPureApi && { mutationName: mutationName })), { actionName: actionName, isPureApi: isPureApi, api: api, apiOptions: apiOptions });
                _this.genAction(spectraModule, moduleApiContext);
                if (isPureApi) {
                    pureApiKeys.push(name);
                    delete instance[name];
                }
                else {
                    apiKeys.push(name);
                    instance[name] = apiOptions.defaultState || null;
                    Mutation(SpectraModule.prototype, mutationName, {
                        value: function (data) {
                            this[name] = data;
                        },
                    });
                }
            });
            Reflect.defineMetadata(SPECTRA_APIS_METADATA_KEY, { apiKeys: apiKeys, pureApiKeys: pureApiKeys }, SpectraModule);
            moduleName && Object.defineProperty(SpectraModule, '_vmdModuleName', { value: moduleName });
            //  remove name to avoid vuex-module-decorators namespaced module issue
            return Module(__assign(__assign({}, options), { name: '' }))(SpectraModule);
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "spectraWeaverFactory", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (Component) {
            var spectraModules = Reflect.getMetadata(WEAVER_MODULES_METADATA_KEY, Component);
            if (!(spectraModules === null || spectraModules === void 0 ? void 0 : spectraModules.length)) {
                return Component;
            }
            // this.spectraWeavers.push(Component);
            return createDecorator(function (options) {
                var reduceOptions = spectraModules.reduce(function (prev, module) {
                    var apiKeys = module.apiKeys, pureApiKeys = module.pureApiKeys, _a = module.moduleName, moduleName = _a === void 0 ? null : _a, _b = module.namespaced, namespaced = _b === void 0 ? false : _b;
                    var states = [];
                    var actions = [];
                    var mutations = [];
                    pureApiKeys.forEach(function (item) {
                        actions.push(prefixName(item, 'action'));
                    });
                    apiKeys.forEach(function (item) {
                        states.push(item);
                        mutations.push(prefixName(item, 'mutation'));
                        actions.push(prefixName(item, 'action'));
                    });
                    var namespace = namespaced && moduleName;
                    return {
                        computed: Object.assign(prev.computed, mapState(namespace, states)),
                        methods: Object.assign(prev.methods, mapMutations(namespace, Object.fromEntries(mutations.map(function (key) { return [key, function (commit, data) { return commit(key, data); }]; }))), mapActions(namespace, Object.fromEntries(actions.map(function (key) { return [key, function (dispatch) {
                                var args = [];
                                for (var _i = 1; _i < arguments.length; _i++) {
                                    args[_i - 1] = arguments[_i];
                                }
                                return dispatch(key, args);
                            }]; })))),
                    };
                }, { computed: options.computed || {}, methods: options.methods || {} });
                options.methods = reduceOptions.methods;
                options.computed = reduceOptions.computed;
            })(Component);
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "genAction", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (spectraModule, moduleApiContext) {
            var aopMethods = {
                beforeActions: this.initAopMethods(moduleApiContext.name, this.globalPrismMap.beforeActions, spectraModule.beforeActions),
                pendingActions: this.initAopMethods(moduleApiContext.name, this.globalPrismMap.pendingActions, spectraModule.pendingActions),
                afterActions: this.initAopMethods(moduleApiContext.name, this.globalPrismMap.afterActions, spectraModule.afterActions),
            };
            Action({ rawError: moduleApiContext.apiOptions.rawError || true })(spectraModule.module.prototype, moduleApiContext.actionName, {
                value: function (apiArgs) {
                    var _this = this;
                    var moduleActionContext = __assign(__assign(__assign({}, moduleApiContext), aopMethods), { apiArgs: null, apiPromise: null, apiResult: null });
                    var beforeActions = moduleActionContext.beforeActions, pendingActions = moduleActionContext.pendingActions, afterActions = moduleActionContext.afterActions, isPureApi = moduleActionContext.isPureApi, extractDataKey = moduleActionContext.extractDataKey, mutationName = moduleActionContext.mutationName;
                    var context = this.context;
                    moduleActionContext.apiArgs = apiArgs;
                    getAopMethods(beforeActions).forEach(function (fn) { return fn.call(_this, context, moduleActionContext); });
                    moduleActionContext.apiPromise = moduleActionContext.api.apply(moduleActionContext, apiArgs);
                    getAopMethods(pendingActions).forEach(function (fn) { return fn.call(_this, context, moduleActionContext); });
                    return moduleActionContext.apiPromise
                        .then(function (res) {
                        moduleActionContext.apiResult = (extractDataKey === null || extractDataKey === void 0 ? void 0 : extractDataKey.split('.').reduce(function (result, key) { return result === null || result === void 0 ? void 0 : result[key]; }, res)) || res;
                        !isPureApi && context.commit(mutationName, moduleActionContext.apiResult);
                        return moduleActionContext.apiResult;
                    })
                        .catch(function (e) {
                        moduleActionContext.apiResult = e;
                        return Promise.reject(e);
                    })
                        .finally(function () { return getAopMethods(afterActions).forEach(function (fn) { return fn.call(_this, context, moduleActionContext); }); });
                },
            });
        }
    });
    Object.defineProperty(SpectraCreator.prototype, "initAopMethods", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (name, globalMethods, moduleMethods) {
            if (moduleMethods === void 0) { moduleMethods = []; }
            var methods = [];
            methods.globalMethods = globalMethods;
            methods.moduleMethods = moduleMethods;
            methods.name = name;
            return methods;
        }
    });
    return SpectraCreator;
}());

function apiAction(api) {
    return api;
}
function Api(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        Reflect.defineMetadata(API_OPTIONS_METADATA_KEY, options, target, key);
        Reflect.defineMetadata(API_TYPE_METADATA_KEY, 'default', target, key);
    };
}
function ApiAction(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        Reflect.defineMetadata(API_OPTIONS_METADATA_KEY, options, target, key);
        Reflect.defineMetadata(API_TYPE_METADATA_KEY, 'pure', target, key);
    };
}

var _a = new SpectraCreator({ extractDataKey: 'data' }), Weaver = _a.Weaver, Spectra = _a.Spectra;
function getModule(module) {
    return module;
}

export { Api, ApiAction, Exclude, Include, Order, Spectra, SpectraModule, SpectraPrism, Weaver, apiAction, SpectraCreator as default, getModule };
//# sourceMappingURL=index.js.map
